const init_fs_pdf_modal = function () {
    // console.log('pdf-modal');
    // console.log($('[data-pdf-modal]').length);

    $('[data-pdf-modal]').on('click', function (e) {
        $modal_datas = $(this).data('pdf-modal');
        $pdf_url = $modal_datas.src;
        $pdf_title = $modal_datas.title;
        if ('' === $pdf_url || 'undefined' === typeof $pdf_url) {
            return;
        }

        e.preventDefault();

        let $pdf_modal_html = '<div id="fs-pdf-modal" class="modal fade" tabindex="-1" aria-hidden="true">\n' +
            '  <div class="modal-dialog modal-xl">\n' +
            '    <div class="modal-content">\n' +
            '      <div class="modal-header">\n' +
            '        <h5 class="modal-title">{{title}}</h5>\n' +
            '        <button type="button" class="close" data-dismiss="modal" aria-label="Close">\n' +
            '          <span aria-hidden="true">&times;</span>\n' +
            '        </button>\n' +
            '      </div>\n' +
            '      <div class="modal-body">\n' +
            '    <div>\n' +
            '        <iframe style="overflow:hidden;height:80vh;width:100%" height="100%" width="100%"\n' +
            '                src="/wp-content/plugins/pdfjs-viewer-shortcode/pdfjs/web/viewer.php?file={{pdf_src}}&#038;attachment_id=0&#038;dButton=true&#038;pButton=true&#038;oButton=false&#038;sButton=true#zoom=auto&#038;pagemode=none&#038;_wpnonce=b1ac065e34"\n' +
            '                title="Embedded PDF" className="pdfjs-iframe"></iframe>\n' +
            '    </div>\n' +
            '      </div>\n' +
            '    </div>\n' +
            '  </div>\n' +
            '</div>\n';

        if ($("#fs-pdf-modal").length) {
            $("#fs-pdf-modal").remove();
        }

        // $("#fs-pdf-modal-iframe").attr('src', $pdf_url);
        // $("#fs-pdf-modal .modal-title").html($pdf_title);
        $pdf_modal_html_title = $pdf_modal_html.replace('{{title}}', $pdf_title);
        $pdf_modal_html_all = $pdf_modal_html_title.replaceAll('{{pdf_src}}', $pdf_url);
        $('body').append($pdf_modal_html_all);
        $fs_pdf_modal = window.$("#fs-pdf-modal");
        $fs_pdf_modal.modal('show');
    });
}

$(document).ready(function () {
    init_fs_pdf_modal();
})